/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.chevron-up\":[\"Pil opad\"]}");